module.exports = __webpack_public_path__ + "img/Q.bc47f52d.jpg";